module.exports = "<p-button icon=\"fa fa-plus\" label=\"{{ 'LAYOUT:BUTTON:ADD_SUPPORT' | translate }}\" (onClick)=\"showAddSupport()\"></p-button>\r\n"